document.addEventListener('DOMContentLoaded', function () {
  const proxyPathEl = document.getElementById('proxyPathDiv');
  const websiteCodeEl = document.querySelector('#websiteCode');
  if (!proxyPathEl || !websiteCodeEl) return;

  const proxyPath = proxyPathEl.dataset.proxyPath;
  const websiteCode = websiteCodeEl.dataset.id;
  const wishlistUrl = proxyPath + '/customer/wishlist';

  document.querySelectorAll('.wishlist_fav').forEach((btn) => {
    btn.addEventListener('click', async (event) => {
      const element = event.currentTarget;

      if (element.dataset.disabled === 'true') return;

      element.dataset.disabled = 'true';
      element.classList.add('is-loading');

      try {
        const r = await fetch(wishlistUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            productId: element.dataset.productId,
            websiteCode,
            action: element.dataset.action
          })
        });

        if (r.ok) {
          const other = element.parentElement.querySelector(
            `.wishlist_fav[data-action="${element.dataset.action === 'add' ? 'remove' : 'add'}"]`
          );
          if (other) {
            element.style.display = 'none';
            other.style.display = 'block';
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        element.dataset.disabled = 'false';
        element.classList.remove('is-loading');
        if (window.location.pathname.endsWith('/pages/wishlist')) {
          element.closest('.grid__item')?.remove();
        }
      }
    });
  });

  const clearWishlistButton = document.getElementById('clearWishlist');
  if (clearWishlistButton) {
    clearWishlistButton.addEventListener('click', async () => {
      try {
        const r = await fetch(wishlistUrl, {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ websiteCode })
        });
        if (r.ok) window.location.reload();
      } catch (err) {
        console.error(err);
      }
    });
  }
});
